// ── Two Truths One Lie — Host Screen ─────────────────────────────────────────

const ACCENT = "#B24BF3";

export default function TwoTruthsHost({ data, voteData, voteProgress, result, players, onSkipInput, tv }) {
  const fs = (a, b) => tv ? a : b;

  // ── Result ────────────────────────────────────────────────────────────────
  if (data?.phase === "result" && result) {
    const sorted = Object.entries(result.scores || {}).sort((a, b) => b[1] - a[1]);
    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        gap: fs("1rem", "0.7rem"), maxWidth: "700px", margin: "0 auto", width: "100%",
      }}>
        <div style={{ fontSize: fs("2.5rem", "1.8rem") }}>🤥</div>
        <div className="font-display text-center" style={{ fontSize: fs("1.6rem", "1.1rem"), color: ACCENT }}>
          Правда раскрыта!
        </div>

        {/* Facts with reveal */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
          {(result.facts || []).map((fact, i) => {
            const isLie = i === result.lie_index;
            const voteCount = result.vote_distribution?.[i] || 0;
            return (
              <div key={i} style={{
                background: isLie ? "#ff335522" : "#00cc6622",
                border: `2px solid ${isLie ? "#ff3355" : "#00cc66"}`,
                borderRadius: "1rem", padding: fs("0.8rem 1.2rem", "0.5rem 0.8rem"),
                display: "flex", alignItems: "center", gap: "0.8rem",
              }}>
                <div style={{ fontSize: fs("1.5rem", "1.1rem"), flexShrink: 0 }}>
                  {isLie ? "❌" : "✅"}
                </div>
                <div style={{ flex: 1 }}>
                  <div className="font-heading text-white" style={{ fontSize: fs("1rem", "0.8rem"), lineHeight: 1.4 }}>
                    {fact}
                  </div>
                  <div className="font-heading" style={{
                    color: isLie ? "#ff3355" : "#00cc66",
                    fontSize: fs("0.8rem", "0.65rem"), marginTop: "0.2rem",
                  }}>
                    {isLie ? "👈 ЭТО ЛОЖЬ" : "ПРАВДА"} · {voteCount} голос{voteCount === 1 ? "" : "ов"}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {result.subject_score > 0 && (
          <div className="font-heading text-center" style={{ color: ACCENT, fontSize: fs("1rem", "0.8rem") }}>
            😈 {result.subject} обманул(а) {result.subject_score / 75} чел → +{result.subject_score} очков
          </div>
        )}

        {/* Scores */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", minWidth: "200px", width: "100%", maxWidth: "340px" }}>
          {sorted.map(([name, score], i) => {
            const pl = players.find(p => p.name === name);
            return (
              <div key={name} style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                background: i === 0 ? "#ffe60015" : "#ffffff08",
                border: `1.5px solid ${i === 0 ? "#ffe60055" : "#ffffff11"}`,
                borderRadius: "0.6rem", padding: fs("0.4rem 0.75rem", "0.3rem 0.6rem"),
              }}>
                <span className="font-heading" style={{ color: i === 0 ? "#ffe600" : "#fff", fontSize: fs("1rem", "0.8rem") }}>
                  {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : "  "} {name}
                  {name === result.subject && <span style={{ color: ACCENT, fontSize: "0.7em" }}> 🤥</span>}
                </span>
                <span className="font-display" style={{ color: pl?.color || "#aaa", fontSize: fs("1rem", "0.8rem") }}>{score}</span>
              </div>
            );
          })}
        </div>
        <div className="font-heading text-[#555]" style={{ fontSize: fs("0.8rem", "0.65rem") }}>
          Раунд {result.round}/{result.max_rounds} · Следующий раунд...
        </div>
      </div>
    );
  }

  // ── Voting ────────────────────────────────────────────────────────────────
  if (data?.phase === "voting" && voteData) {
    const voted = voteProgress?.voted_count || 0;
    const total = voteProgress?.total || 0;
    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        gap: fs("1rem", "0.7rem"), maxWidth: "700px", margin: "0 auto", width: "100%",
      }}>
        <div className="font-display text-center" style={{ fontSize: fs("1.5rem", "1.1rem"), color: ACCENT }}>
          🤔 Что ложь?
        </div>
        <div className="font-heading text-[#aaa] text-center" style={{ fontSize: fs("0.9rem", "0.75rem") }}>
          {voteData.subject} рассказал(а) о себе:
        </div>

        {/* Facts */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
          {(voteData.facts || []).map((fact, i) => (
            <div key={i} style={{
              background: "#ffffff0a", border: "1.5px solid #ffffff22",
              borderRadius: "1rem", padding: fs("0.8rem 1.2rem", "0.5rem 0.8rem"),
              display: "flex", alignItems: "center", gap: "0.8rem",
            }}>
              <div style={{
                width: fs("2rem", "1.6rem"), height: fs("2rem", "1.6rem"), borderRadius: "50%",
                background: ACCENT, display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontSize: fs("1rem", "0.8rem"), flexShrink: 0,
              }}>
                <span className="font-display">{i + 1}</span>
              </div>
              <div className="font-heading text-white" style={{ fontSize: fs("1rem", "0.8rem"), lineHeight: 1.4 }}>
                {fact}
              </div>
            </div>
          ))}
        </div>

        {/* Progress */}
        <div className="font-heading text-[#aaa]" style={{ fontSize: fs("0.85rem", "0.7rem") }}>
          Проголосовали: {voted}/{total}
        </div>
        <div style={{ background: "#111", borderRadius: "0.5rem", height: "8px", width: "200px", overflow: "hidden" }}>
          <div style={{
            background: ACCENT, height: "100%",
            width: total > 0 ? `${(voted / total) * 100}%` : "0%",
            transition: "width 0.3s",
          }} />
        </div>
      </div>
    );
  }

  // ── Waiting for input ─────────────────────────────────────────────────────
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      gap: fs("1rem", "0.7rem"), maxWidth: "700px", margin: "0 auto", width: "100%", textAlign: "center",
    }}>
      <div style={{ fontSize: fs("3rem", "2rem") }}>🤥</div>
      <div className="font-display" style={{ fontSize: fs("1.8rem", "1.3rem"), color: ACCENT }}>
        {data?.subject} пишет факты...
      </div>
      <div style={{
        background: "#111", border: "1.5px solid #333",
        borderRadius: "1rem", padding: fs("1rem 1.5rem", "0.7rem 1rem"), width: "100%",
      }}>
        <div className="font-heading text-[#aaa]" style={{ fontSize: fs("0.8rem", "0.65rem"), marginBottom: "0.3rem" }}>📋 ТЕМА</div>
        <div className="font-heading text-white" style={{ fontSize: fs("1rem", "0.8rem"), lineHeight: 1.4 }}>
          {data?.prompt}
        </div>
      </div>
      <div className="font-heading text-[#555]" style={{ fontSize: fs("0.85rem", "0.7rem") }}>
        Игрок вводит 2 правды и 1 ложь на телефоне
      </div>
      <button onClick={onSkipInput} style={{
        background: "#333", border: "2px solid #555", borderRadius: "0.75rem",
        padding: fs("0.5rem 1.2rem", "0.3rem 0.8rem"), color: "#aaa", cursor: "pointer",
        fontSize: fs("0.85rem", "0.7rem"),
      }}>
        <span className="font-heading">⏭ Пропустить</span>
      </button>
      <div className="font-heading text-[#555]" style={{ fontSize: fs("0.8rem", "0.65rem") }}>
        Раунд {data?.round}/{data?.max_rounds}
      </div>
    </div>
  );
}
